// ProcessPage.jsx
import { useParams, useLocation } from "react-router-dom";

export const ProcessPage = () => {
  const { productId } = useParams();
  const location = useLocation();
  const productName = location.state?.productName || "Product";

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <h2>Process Management for {productName} (ID: {productId})</h2>
          {/* Add your process management logic here */}
        </div>
      </div>
    </div>
  );
};